import { AUDIENCE_TYPES, AUDIENCE_TYPES_ARRAY } from "posts/constants";
import Card, { CardTitle } from "./Card";
import React, { useState } from "react";

import { BORDER_RADIUS } from "utils/styles";
import CompareModal from "./CompareModal";
import Picture from "components/Picture";
import styled from "styled-components";
import { getAudienceEmoji } from "posts/constants";

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 0.5rem;
  grid-row-gap: 0.5rem;

  @media (min-width: 30em) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  @media (min-width: 40em) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }
  @media (min-width: 50em) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  @media (min-width: 60em) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }

  ${({ small }) =>
    small
      ? `
    grid-template-columns: 1fr 1fr;
    @media (min-width: 30em) {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
    @media (min-width: 70em) {
      grid-template-columns: 1fr 1fr;
    }
  `
      : ""};
`;

const StyledPicture = styled(Picture)`
  img {
    ${BORDER_RADIUS};
    width: 100%;
  }
`;

function GalleryCard({ activeAudience }) {
  const [showCompare, setShowCompare] = useState(false);

  const renderImage = (src, alt, small) => {
    return <StyledPicture image={src} imageAlt={alt} />;
  };

  const renderImageGrid = (audience, small) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return (
          <Grid small={small}>
            {renderImage(
              "/images/profiles-tough-cookies-photos-1.png",
              "Salmon breakfast sandwich health recipe, easy to make",
              small
            )}
            {renderImage(
              "/images/profiles-tough-cookies-photos-2.png",
              "Quinoa avocado salad recipe",
              small
            )}
            {renderImage(
              "/images/profiles-tough-cookies-photos-3.png",
              "Neflix series poster: Self Made",
              small
            )}
            {renderImage(
              "/images/profiles-tough-cookies-photos-4.png",
              "John Denver: Poems, Prayers &amp; Promises album cover",
              small
            )}
            {renderImage(
              "/images/profiles-tough-cookies-photos-5.png",
              "MSNBC headline: MSNBC and CNN to host climate events for the presidential candidates",
              small
            )}
            {renderImage(
              "/images/profiles-tough-cookies-photos-6.png",
              "Movie poster: Spenser Confidential",
              small
            )}
            {renderImage(
              "/images/profiles-tough-cookies-photos-7.png",
              "Gaither Vocal Band Runion Live poster",
              small
            )}
            {renderImage(
              "/images/profiles-tough-cookies-photos-8.png",
              "Tampa Bay Buccaneers logo and poster",
              small
            )}
            {renderImage(
              "/images/profiles-tough-cookies-photos-9.png",
              "DIY-er standing in front of a several power and hand tools",
              small
            )}
            {renderImage(
              "/images/profiles-tough-cookies-photos-10.png",
              "Poster for TV series The Virginian",
              small
            )}
          </Grid>
        );
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return (
          <Grid small={small}>
            {renderImage(
              "/images/profiles-dont-tread-photos-1.png",
              "The Pharmacist TV show poster",
              small
            )}
            {renderImage(
              "/images/profiles-dont-tread-photos-2.png",
              "Axel Rose sitting cross-legged on the ground",
              small
            )}
            {renderImage(
              "/images/profiles-dont-tread-photos-3.png",
              "Screenshot of James Woods from the film White House Down",
              small
            )}
            {renderImage(
              "/images/profiles-dont-tread-photos-4.png",
              "Waco TV show poster",
              small
            )}
            {renderImage(
              "/images/profiles-dont-tread-photos-5.png",
              "Photo of flags at a PGA event",
              small
            )}
            {renderImage(
              "/images/profiles-dont-tread-photos-6.png",
              "Led Zepplin 1 album cover",
              small
            )}
            {renderImage(
              "/images/profiles-dont-tread-photos-7.png",
              "Extraction movie poster",
              small
            )}
            {renderImage(
              "/images/profiles-dont-tread-photos-8.png",
              "Screenshot from the TV show Witcher",
              small
            )}
            {renderImage(
              "/images/profiles-dont-tread-photos-9.png",
              "Linkin Park band logo",
              small
            )}
            {renderImage(
              "/images/profiles-dont-tread-photos-10.png",
              "Screenshot from a mixed martial arts match",
              small
            )}
          </Grid>
        );
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return (
          <Grid small={small}>
            {renderImage(
              "/images/profiles-peoplepower-photos-1.png",
              "Hamilton movie poster",
              small
            )}
            {renderImage(
              "/images/profiles-peoplepower-photos-2.png",
              "Group photo of K-Pop group BTS",
              small
            )}
            {renderImage(
              "/images/profiles-peoplepower-photos-3.png",
              "Yoga, woman sitting in lotus position",
              small
            )}
            {renderImage(
              "/images/profiles-peoplepower-photos-4.png",
              "Cookbook cover: Chrissy Teiegen Cravings",
              small
            )}
            {renderImage(
              "/images/profiles-peoplepower-photos-5.png",
              "The Irishman movie poster",
              small
            )}
            {renderImage(
              "/images/profiles-peoplepower-photos-6.png",
              "Woman wearing an oversized sweater from Urban Outfitters",
              small
            )}
            {renderImage(
              "/images/profiles-peoplepower-photos-7.png",
              "Young man eating chicken wings",
              small
            )}
            {renderImage(
              "/images/profiles-peoplepower-photos-8.png",
              "Superhero: Miles Morales",
              small
            )}
            {renderImage(
              "/images/profiles-peoplepower-photos-9.png",
              "Barack Obama throwing a basketball",
              small
            )}
            {renderImage(
              "/images/profiles-peoplepower-photos-10.png",
              "Drake",
              small
            )}
          </Grid>
        );
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return (
          <Grid small={small}>
            {renderImage(
              "/images/profiles-if-you-say-so-photos-1.png",
              "Photo of Jefree Star",
              small
            )}
            {renderImage(
              "/images/profiles-if-you-say-so-photos-2.png",
              "Album cover: Post Malone - Stoney",
              small
            )}
            {renderImage(
              "/images/profiles-if-you-say-so-photos-3.png",
              "Morgana, League of Legends",
              small
            )}
            {renderImage(
              "/images/profiles-if-you-say-so-photos-4.png",
              "Tiger King TV show poster",
              small
            )}
            {renderImage(
              "/images/profiles-if-you-say-so-photos-5.png",
              "High end kitchens",
              small
            )}
            {renderImage(
              "/images/profiles-if-you-say-so-photos-6.png",
              "Bojack Horseman TV show screenshot",
              small
            )}
            {renderImage(
              "/images/profile-if-you-say-so-photos-hasan.png",
              "Hasan Minhaj",
              small
            )}
            {renderImage(
              "/images/profiles-if-you-say-so-photos-8.png",
              "Twitch logo",
              small
            )}
            {renderImage(
              "/images/profiles-if-you-say-so-photos-9.png",
              "Contemporary kitchen with white cabinets and green tile",
              small
            )}
            {renderImage(
              "/images/profiles-if-you-say-so-photos-10.png",
              "Valorant Ignition Series esports tournament",
              small
            )}
          </Grid>
        );
    }
  };
  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        Gallery
      </CardTitle>
      {renderImageGrid(activeAudience)}
      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>Compare Audiences – Gallery</CompareModal.Title>
        </CompareModal.Header>
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`gallery-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    {renderImageGrid(type, true)}
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}

export default GalleryCard;
